import { render } from "./ProgressBar.vue?vue&type=template&id=22a74461&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"

import "./ProgressBar.vue?vue&type=style&index=0&id=22a74461&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22a74461"

export default script